import 'intl';
import 'intl/locale-data/jsonp/en-GB';

import axios from 'axios';
import * as e6p from 'es6-promise';
import * as React from 'react';
import { hydrate, unmountComponentAtNode } from 'react-dom';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { createBrowserHistory } from 'history';
import { configureStore } from './app/redux/store';
import App from './app';
import * as a11y from 'react-a11y';
import AuthInterceptor from './app/helpers/AuthInterceptor';

// import * as injectTapEventPlugin from 'react-tap-event-plugin';
import { AppContainer } from 'react-hot-loader';
import { JobProvider } from 'react-jobs';
import { Modal } from 'react-overlays';

// injectTapEventPlugin();

e6p.polyfill();

if (process.env.NODE_ENV === 'local') {
  a11y(React);
}

Modal.prototype.componentWillMount = function() {
  this.focus = () => null;
};

axios.defaults.baseURL = window.__API_URL__;

const rehydrateState = window.__JOBS_STATE__;
const history = createBrowserHistory();
const store = configureStore(
  history,
  window.__INITIAL_STATE__,
);
const state = store.getState();
const mountNode = document.getElementById('app');
new AuthInterceptor(store).registerInterceptor();

const renderIt = (Component) => {
  hydrate(
    <AppContainer>
      <JobProvider rehydrateState={rehydrateState}>
        <Provider store={store}>
          <IntlProvider locale={state.branding.locale} messages={state.branding.i18n}>
            <ConnectedRouter
              history={history}
            >
              <Component branding={state.branding} />
            </ConnectedRouter>
          </IntlProvider>
        </Provider>
      </JobProvider>
    </AppContainer>,
    mountNode,
  );
};

renderIt(App);

if (module.hot) {
  module.hot.accept('./app', () => {
    const newApp = require('./app').default;

    setImmediate(() => {
      // Preventing the hot reloading error from react-router
      unmountComponentAtNode(mountNode);
      renderIt(newApp);
    });
  });
}
